import { Controller, useFormContext } from 'react-hook-form'

import { Button } from '@/components/ui/button.tsx'
import { classNames } from '@/utils/helpers'

interface Props {
  className?: string
  options: { label: string; value: string }[]
  onValueChange: (value: string) => void
}

export const Switcher = ({ className, options, onValueChange }: Props) => {
  const form = useFormContext()

  return (
    <Controller
      control={form.control}
      name="priority"
      defaultValue="trending"
      render={({ field: { onChange, value } }) => (
        <div
          className={classNames(
            'flex w-max items-center justify-between gap-1 rounded-md border bg-card p-1 dark:hover:bg-secondary-600',
            className,
          )}
        >
          {options.map((option) => (
            <Button
              key={option.value}
              variant={value === option.value ? 'default' : 'ghost'}
              onClick={() => {
                onChange(option.value)
                onValueChange(option.value)
              }}
              className={classNames('h-8 w-[194px]', {
                'text-secondary-300': value !== option.value,
              })}
            >
              {option.label}
            </Button>
          ))}
        </div>
      )}
    />
  )
}
